<template>
  <ElDialog
    :title="$t('APP.REVIEWS.REPORT_BOX_TITLE')"
    :visible="value"
    width="25%"
    top="30vh"
    class="review-report-modal"
    @close="emitInputEvent"
  >
    <span class="review-report-modal__title">
      {{ $t('APP.REVIEWS.REVIEWS_TITLE') }}
    </span>
    <p class="review-report-modal__text">{{ reviewText }}</p>
    <hr class="review-report-modal__divider" />
    <small class="review-report-modal__alert">
      {{ $t('APP.REVIEWS.REPORT_BOX_ALERT') }}
    </small>

    <template #footer>
      <div class="review-report-modal__controls">
        <ElButton type="text" size="small" plain @click.native="emitInputEvent">
          {{ $t('CANCEL') }}
        </ElButton>

        <ElButton type="primary" size="small" @click.native="emitConfirmEvent">
          {{ $t('REPORT_IT') }}
        </ElButton>
      </div>
    </template>
  </ElDialog>
</template>

<script>
export default {
  name: 'ReviewReportModal',

  props: {
    reviewText: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    emitInputEvent() {
      this.$emit('input', false);
    },

    emitConfirmEvent() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss">
.review-report-modal {
  margin: 0;

  &__divider {
    margin: $global-margin 0;
  }

  &__text {
    background: rgba($clouds, 0.8);
    padding: $global-padding / 2;
  }

  &__title {
    display: inline-flex;
    margin-bottom: $global-margin;
  }

  &__controls {
    text-align: left;
  }

  .el-dialog__body {
    padding-top: $global-padding;
    padding-bottom: $global-padding;
  }
}
</style>
